import { FunctionComponent, ReactNode, useState } from "react";
import { observer } from "mobx-react-lite";

import { getStoreContextProvider, store } from "../../../stores/StoreContext";

interface IStoreProviderProps {
  children: ReactNode;
}

const RawStoreProvider: FunctionComponent<IStoreProviderProps> = ({ children }: IStoreProviderProps) => {
  // Trial to fix losing store on hot reloads => but real solution is using another store library like Zustand or Redux
  const [state, setState] = useState(store);

  const StoreContextProvider = getStoreContextProvider();

  return <StoreContextProvider value={state}>{children}</StoreContextProvider>;
};

export const StoreProvider = observer(RawStoreProvider);
